import Button from "components/Buttons/Button";
import React from "react";
import { ReactComponent as TransferWalletIcon } from "assets/TransferWallet.svg";

interface ITransferConfirmationModalProps {
  onTransfer: () => void;
  onCancel: () => void;
  transferAmount?: number;
  transferringAmount: boolean;
}

const TransferConfirmationModal: React.FC<ITransferConfirmationModalProps> = ({
  onTransfer,
  onCancel,
  transferAmount = 0,
  transferringAmount,
}) => {
  return (
    <div className="flex flex-col h-full flex-1">
      <div className="flex-1 gap-4 flex flex-col mt-12 items-center">
        <TransferWalletIcon className="inline-block h-18 w-18" />
        <div className="font-semibold text-black text-center md:text-xl">
          Transfer rewards fund balance?
        </div>
        <div className="md:text-sm text-xs text-center text-opacity-80">
          Your balance of{" "}
          <span className="text-secondary">${transferAmount}</span> will be
          refunded to your original payment method.
        </div>
      </div>
      <div className="flex md:flex-row flex-col  w-full self-center justify-center no-scrollbar">
        <Button label={"Cancel"} onClick={onCancel} variant="secondary" />
        <Button
          label={"Initiate transfer"}
          onClick={onTransfer}
          loading={transferringAmount}
        />
      </div>
    </div>
  );
};

export default TransferConfirmationModal;
